export default __webpack_public_path__ + "/dist/images/yourdata-active.c05241cd2b03d303e9c19a1b99441915.svg";